import React, {useState,useEffect } from "react";
import '../../../css/App.css';
import validatorIndex from "../../../utilities/validators/validatorIndex";
import NonTwrRefOption from "./nonTwrRefOption";
import TwrPathRequirement from "./twrPathRequirement";
import { Box, Paper, Grid, Typography } from  '@mui/material';


function PathDisplayBlock(props){

    const [header,setHeader]=useState((validatorIndex[props.eachPath[0]]["displayAs"]));
    const [pathway, setPathway]=useState((props.eachPath[0]))
    const [displayStyle, setDisplayStyle]=useState()

    const message=(props.modifiedFormData.message[props.eachPath[0]])
    let twrPaths=props.modifiedFormData.twrValid

    let benignPaths=[]
    let pathwayToOffer=[]

    if (twrPaths[props.eachPath[0]])
        {
        pathwayToOffer=<TwrPathRequirement pathway={pathway} readablePath={header} />
        }
    else
       {
         benignPaths=validatorIndex[pathway]["specialty"]
         pathwayToOffer=benignPaths.map((pathway, index)=><NonTwrRefOption pathway={pathway} readablePath={pathway} key={index} />)
       }
          

    //set styling option for diplay block by setting CSS class
    useEffect(()=>{
        if (twrPaths[props.eachPath[0]])
        {
        setDisplayStyle("pathDisplayBlocktwr")
        }
    else if (message !=="")
        {
        setDisplayStyle("pathDisplayBlockConditional")
        }
    else
        {
        setDisplayStyle("pathDisplayBlockNotTwr")
        }
    },[twrPaths, props.eachPath, message])
            
    let notTWR=`The patient's symptoms do NOT meet the NICE 2wr criteria for the ${header} pathway`
    let messageToDisplay=((message !=="" || twrPaths[props.eachPath[0]]) ? message : notTWR)
    let clinicHeader= (benignPaths.length > 0 ? "Non RDC referral options to consider:" : "")
      

    return(
    <Grid item sx={{p:1}} xs={12} sm={6} md={6}>
    <Paper elevation = {5} >
    <Box className={displayStyle}>
    <h2>{header}</h2>
    <div className="pathMessage">{messageToDisplay}</div>
    <div><Typography variant="subtext1">{clinicHeader}</Typography></div>
    <div className="pathToOffer">{pathwayToOffer} </div>
    </Box>
    </Paper>
    </Grid>
    )
    }

    export default PathDisplayBlock
